module.exports = __webpack_public_path__ + "static/img/excel.37fd3275.svg";